/**
 * Processes the watch providers data for a specific movie.
 * Extracts streaming services available in the specified country.
 * @param {object} providersData - The raw providers data from TMDb.
 * @param {string} unusedCountryCode - Ignored, based on user locale, The country code to filter the providers by (e.g., 'US', 'GB').
 * @returns {object[]} - An array of streaming services with their names and logos.
 */
export const processStreamingServices = (providersData, unusedCountryCode) => {
  if (!providersData) return [];

  // Find Local, pick US or GB fall back to GB
  const countryCode = wp && wp.countryCode ? wp.countryCode : 'GB';  // Default to 'GB' if not available

  const countryProviders = providersData[countryCode];
  const streamingServices = [];

  if (countryProviders.flatrate) {
    countryProviders.flatrate.forEach(provider => {
      streamingServices.push({
        name: provider.provider_name,
        logoPath: (window.innerWidth <= 768) ? `https://image.tmdb.org/t/p/w92${provider.logo_path}`: `https://image.tmdb.org/t/p/w154${provider.logo_path}`,
      });
    });
  }

  return streamingServices;
};
